import React from 'react';

import { useTheme } from '@mui/material/styles';

const HighlightAsterisks = ({
  text,
  disabled
}: {
  text?: string;
  disabled?: boolean;
}) => {
  const theme = useTheme();
  if (!text) return null;

  const parts = text.split('*');

  const interactionPrimary = theme.palette.interaction.primary;

  return (
    <>
      {parts.map((part, index) => {
        if (part === '') {
          return null;
        }
        return (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && !disabled && (
              <span style={{ color: interactionPrimary }}>*</span>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default HighlightAsterisks;
